import { supabase } from "../supabase";
import { devLog } from "./devLog";

export const MIN_PASSWORD_LENGTH = 8;

/** Canonical production app origin — used for docs and hosting validation only. */
export const CANONICAL_PRODUCTION_APP_URL = "https://app.nexorasystems.ca";

/**
 * Temporary Vercel fallback origin — keep registered in Supabase redirect URLs
 * until production verification on app.nexorasystems.ca is complete.
 */
export const LEGACY_VERCEL_APP_URL = "https://voice-intake-app.vercel.app";

/**
 * Origin used for Supabase auth redirects (OAuth, email confirm, password reset).
 * Always reflects the current deployment so localhost, preview, production, and
 * legacy fallback domains work without hardcoded URLs in call sites.
 */
export function getAuthRedirectUrl() {
  if (typeof window === "undefined" || !window.location?.origin) {
    return CANONICAL_PRODUCTION_APP_URL;
  }
  return window.location.origin;
}

export function getPasswordResetRedirectUrl() {
  return getAuthRedirectUrl();
}

export function isRecoveryCallback() {
  const hash = window.location.hash || "";
  const search = window.location.search || "";
  const isRecovery =
    hash.includes("type=recovery") || search.includes("type=recovery");

  if (isRecovery) {
    devLog("[AUTH DEBUG] Recovery callback detected in URL");
  }

  return isRecovery;
}

export function clearRecoveryUrlParams() {
  const cleanUrl = window.location.origin + window.location.pathname;
  window.history.replaceState({}, document.title, cleanUrl);
  devLog("[AUTH DEBUG] Cleared recovery URL params");
}

export async function requestPasswordReset(email) {
  const redirectTo = getPasswordResetRedirectUrl();
  devLog("[AUTH DEBUG] requestPasswordReset", {
    emailProvided: Boolean(email),
    redirectTo,
  });

  const response = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo,
  });

  devLog("[AUTH DEBUG] requestPasswordReset response", {
    hasError: Boolean(response.error),
    status: response.status ?? response.error?.status ?? null,
  });

  if (response.error) {
    devLog("[AUTH DEBUG] requestPasswordReset error", {
      message: response.error.message,
      code: response.error.code,
    });
  }

  return { error: response.error };
}
